import type { LooseObject } from '@piccolohealth/util';
import React from 'react';
import { ChakraV3 } from '../..';
import { CommandInput } from './CommandInput';
import type { CommandMenuContext, FreePage } from './CommandMenu';

interface Props<A> {
  page: FreePage<A>;
  context: CommandMenuContext<A>;
  args?: LooseObject;
}

export const CommandFreePageContent = <A,>(props: Props<A>) => {
  const { page, context, args } = props;

  return (
    <ChakraV3.Flex flexDir='column' w='full'>
      <ChakraV3.Box borderBottom='1px solid' borderColor='gray.300'>
        <CommandInput
          currentPagesLength={context.currentPagesLength}
          popPage={context.popPage}
          value={page.rawTitle}
          readOnly
          disabled
          isSearchable={false}
        />
      </ChakraV3.Box>
      <ChakraV3.Box flexGrow={1} overflowY='auto' w='full'>
        {page.body(context, args)}
      </ChakraV3.Box>
    </ChakraV3.Flex>
  );
};
